
document.addEventListener('DOMContentLoaded', function() {
    const heroGlobal = document.querySelector('.hero-global');
    if (!heroGlobal) return;

    const video = heroGlobal.querySelector('video');
    const playPauseBtn = heroGlobal.querySelector('.hero-global__video-control');

    if (!video || !playPauseBtn) return;

    // Autoplay video on page load
    video.play().catch(e => {
        console.log('Video autoplay failed:', e);
    });

    // Play/Pause button functionality
    playPauseBtn.addEventListener('click', function() {
        if (video.paused) {
            video.play();
            playPauseBtn.classList.remove('paused');
        } else {
            video.pause();
            playPauseBtn.classList.add('paused');
        }
    });

    // Handle video events
    video.addEventListener('play', function() {
        playPauseBtn.classList.remove('paused');
    });

    video.addEventListener('pause', function() {
        playPauseBtn.classList.add('paused');
    });
});
